import { IProject } from "../Models/interfaces/IProject";

export const Projects: IProject[] = [
  {
    id: '1028e324-3aa9-457e-812e-7ac649133e5f',
    theme: '#3f7496',
    name: 'React',
    publishedDate: 'December 2023',
    category: 'Learning (Solely for learning purpose)',
    title: 'Learning to build an application using react.',
    description: 'Come along and witness the evolution of my ReactJS app as I navigate through its creation from scratch. Follow my journey to observe the progress made, explore the learning process, and uncover the milestones shaping this exciting project!',
    backgroundImageUrl: '../../../../../assets/img/projectui/portfolioblob2.svg',
    coverImageUrl: '../../../../../assets/img/projectui/react_practice.png',
    projectUrl: 'https://huzaifafcrit.github.io/starting-react/'
  },
  {
    id: '1028e324-3aa9-457e-812e-7ac649133e5f',
    theme: '#195ac4',
    name: 'Metricstics',
    publishedDate: 'November 2023',
    category: 'Productivity & Utilities',
    title: 'Discover the Power of Metrics and Statistics',
    description: 'METRICSTICS, a fusion of METRICS and STATISTICS, is your tool developed using purely python for calculating essential statistical values - m, M, o, d, μ, MAD, and σ. This system processes random data sets, enabling accurate descriptive statistics calculations. METRICSTICS streamlines complex statistical calculations for analysts, researchers, and data scientists, offering precise insights crucial for informed decision-making in diverse industries.',
    backgroundImageUrl: '../../../../../assets/img/projectui/TDBG.svg',
    coverImageUrl: '../../../../../assets/img/projectui/metricstics.png',
    projectUrl: 'https://github.com/huzaifafcrit/METRICSTICS'
  },
  {
    id: '1028e324-3aa9-457e-812e-7ac649133e5f',
    theme: '#189745',
    name: 'MyTasks',
    publishedDate: 'December 2022',
    category: 'Productivity & Tracking',
    title: 'A lucid to do application for managing and tracking day to day activities.',
    description: 'MyTasks is a cross platform cloud-based progressive web application for task management. It allows users to manage their tasks from a smartphone, tablet and computer.',
    backgroundImageUrl: '../../../../../assets/img/projectui/TDBG.svg',
    coverImageUrl: '../../../../../assets/img/projectui/mockup_todo.png',
    projectUrl: 'https://ha-todo.web.app/'
  },
  {
    id: 'cb0e78b6-e62d-4fd9-9a47-dbad036855fd',
    theme: 'orangered',
    name: 'SNKRS',
    publishedDate: 'May 2022',
    category: 'E-Commerce',
    title: 'An online e-commerce web application for browsing and buying sneakers',
    description: 'A cross platform progressive e-commerce web application for purchasing sneakers. Users can view, search and filter from a wide range of sneakers to find the sneaker of their choice. LoggedIn users can review, wishlist, buy and track their orders. From browsing to checkout this application delivers the best in class user experience.',
    backgroundImageUrl: '../../../../../assets/img/projectui/snkrsblob.svg',
    coverImageUrl: '../../../../../assets/img/projectui/mockup_snkr_store.png',
    projectUrl: 'https://huzaifafcrit.github.io/snkrs'
  },
  {
    id: '9b5ec3d5-4258-4ccb-9e2f-fe66c5108e45',
    theme: '#000061',
    name: 'Helpdesk',
    publishedDate: 'Feb 2022',
    category: 'Support',
    title: 'A web application for requesting for an asset or raising an issue.',
    description: 'Helpdesk is a cross platform cloud-based progressive web application for fullfilling user requests and resolving issues raised by an user. It allows users to manage their requests/issues from a laptop, tablet and computer.',
    backgroundImageUrl: '../../../../../assets/img/projectui/helpdeskblob.svg',
    coverImageUrl: '../../../../../assets/img/projectui/HDC.png',
    projectUrl: 'https://ha-helpdesk.web.app/'
  },
  {
    id: '71856f56-f387-4d35-931f-9dba735b8ad1',
    theme: '#4E4E72',
    name: 'HuzaifaAnjum',
    publishedDate: 'November 2021',
    category: 'Portfolio',
    title: 'Personal portfolio site',
    description: 'Developed and hosted my own portfolio site. This was a personal project which speaks volumes about my journey as a web application developer and a person. It was a fun and thrilling ride working on this webapp. The site in demonstrates my creativity in terms of UI/UX. The site is optimized for delivering a great overall user experience. The user interface is responsive in nature i.e. site can be viewed on devices of different resolutions thanks to bootstrap4, css3 and CSS3 media queries. The site is easily maintainable thanks to Angular and Firebase. CI/CD through Azure DevOps has eased the deployment task. Use of Google Tag Manager and Google Analytics for monitoring site traffic has played a crucial part in understanding the behavior of users visiting the site.',
    backgroundImageUrl: '../../../../../assets/img/projectui/portfolioblob2.svg',
    coverImageUrl: '../../../../../assets/img/projectui/mockup_portfolio.png',
    projectUrl: 'https://huzaifaanjumportfolio.web.app'
  }
  // ,
  // {
  //   id: 'cb0e78b6-e62d-4fd9-9a47-dbad036855fd',
  //   theme: 'navy',
  //   name: 'EMS',
  //   category: 'Management',
  //   title: 'Employee Management tool for managing potential recruits for your organisation.',
  //   description: 'A cross platform progressive web application which helps recruitment team in managing potential talents for your organisation. It securely stores and manages personal and other work-related details for your employees.',
  //   backgroundImageUrl: '../../../../../assets/img/projectui/EMSBG.svg',
  //   coverImageUrl: '../../../../../assets/img/projectui/EMS.png',
  //   projectUrl: 'https://ha-ems.web.app/'
  // },
  // {
  //   id: '71856f56-f387-4d35-931f-9dba735b8ad1',
  //   theme: '#700083',
  //   name: 'ExMS',
  //   category: 'Finance',
  //   title: 'A web application for reimbursement of employee expenses.',
  //   description: 'ExMS or Expense Management System is a cloud-based web application for applying for reimbursement of money spent by an employee during onsite visits. It allows users to upload details of the expenses along with the photo of the bills. Users can use the application from a smartphone, laptop, tablet and computer.',
  //   backgroundImageUrl: '../../../../../assets/img/projectui/ExMSBG.svg',
  //   coverImageUrl: '../../../../../assets/img/projectui/EXMS.png',
  //   projectUrl: '',
  //   detailsId: 3
  // }
]
